import { Palette } from '@/theme/palette';

const rowHeight = 44;

export const getV2GridStyles = (isEmpty: boolean) => {
  const styles = {
    borderRadius: 0,
    border: 'none',
    '& .MuiDataGrid-main': {
      borderBottom: 'none',
      border: 'none'
    },
    '& .MuiDataGrid-virtualScroller': {
      marginTop: `${rowHeight}px !important`
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      borderBottom: `1px solid ${Palette.light.grey['50']}`
    },
    '& .MuiDataGrid-columnHeader': {
      color: Palette.light.text.primary,
      border: 'none',
      borderRight: 'none',
      borderBottom: 'none',
      padding: '16px 12px',
      height: 16,
      '&:not(:last-of-type)': {
        borderRight: 'none'
      }
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '16px',
      color: Palette.light.grey[701]
    },
    '& .MuiDataGrid-cell': {
      outline: 'none !important',
      padding: '5px 16px',
      border: 'none',
      borderRight: 'none',
      borderBottom: `1px solid ${Palette.light.divider}`,
      '&:not(:last-of-type)': {
        borderRight: 'none'
      }
    },
    '& .MuiDataGrid-row': {
      border: 'none',
      '&:last-of-type .MuiDataGrid-cell': {
        borderBottom: 'none'
      }
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: Palette.light.action.hover
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none'
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none'
    },
    '& .MuiDataGrid-menuIcon': {
      display: 'none'
    },
    '& .MuiTablePagination-root': {
      '& .MuiTablePagination-selectLabel, & .MuiSelect-select, & .MuiTablePagination-displayedRows':
        {
          fontWeight: 400,
          fontSize: 12,
          color: Palette.light.text.secondary
        }
    },
    '& .MuiDataGrid-footerContainer': {
      border: 'none',
      borderTop: 'none'
    }
  };
  // looking for a better way to accomplish this empty state-specific style, but for now:
  if (isEmpty) {
    styles['& .MuiDataGrid-virtualScrollerContent'] = {
      height: '72px !important',
      borderBottom: `1px solid ${Palette.light.grey['50']}`
    };
  }
  return styles;
};
